import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EmbedModel } from '../utilities/models/embed-model';
import { UntypedFormControl, Validators } from '@angular/forms';
import { FunctionsService } from '../utilities/services/functions.service';
import { LocaleService } from '@app/system/services/locale.service';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

@Component({
	selector: 'app-embed',
	templateUrl: './embed.component.html',
	styleUrls: ['./embed.component.scss']
})
export class EmbedComponent implements OnInit {

	/**
	 * @desc Angular Input Decorator - Common Parameters
	 * @param object field - text box field data.
	 * @param formControl control - text box control.
	 */
	@Input() field: EmbedModel;
	@Input() control: UntypedFormControl;

	/**
	 * @desc Angular Output Decorator - Common Parameters
	 * @param object helpLineEmit - help line json data.
	 * @param object fieldIconEmit - field icon json data.
	 */
	@Output() helpLineEmit = new EventEmitter();
	@Output() fieldIconEmit = new EventEmitter();

	validationRegex = new RegExp('^(https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\/\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\s]{2,}|www\\.[a-zA-Z0-9]+\.[^\\s]{2,})$', 'gi');

	// 'https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}'
	loader = false;
	paste = false;

	constructor(
		public controlFunctions: FunctionsService,
		public locale: LocaleService,
		private globalApiService: GlobalApiService,
		public detectDevice: DetectDeviceService

	) { }

	ngOnInit(): void {
	}

	embed() {
		if (navigator.onLine) {
			if ((!this.control.errors || (this.control.errors && !this.control.errors.pattern)) && this.control.value) {
				this.loader = true;
				this.control.disable({ emitEvent: false });
				const apiData = {
					// url: (typeof this.control.value === 'object') ? this.control.value.value : this.control.value
					url: this.control.value
				};
				// this.control.reset({ value: { value: this.control.value, apiTrigger: true }, disabled: true });
				this.globalApiService.getEmbedData(apiData).subscribe(
					(response) => {
						if (response) {
							this.control.patchValue(response);
							this.control.clearValidators();
						}
					},
					(error) => {
						this.control.enable({ emitEvent: false });
						this.control.setErrors(
							{
								incorrect: {
									msg: this.field.validationMessage
								}
							}
						);
					}
				)
					.add(() => {
						this.loader = false;
						if (this.control.disabled) {
							this.control.enable({ emitEvent: false });
						}
						// this.control.reset({value: {value: this.control.value, apiTrigger: false}, disabled: false});
					});
			}
		}
	}

	fieldChange() {
		if (navigator.onLine) {
			if (this.paste) {
				if (this.validationRegex.test(this.control.value)) {
					this.embed();
				}
				this.paste = false;
			}
			if (this.control.value && typeof this.control.value !== 'object') {
				this.control.setErrors(
					{
						incorrect: {
							msg: this.locale.translate('url_upload_desc')
						}
					}
				);
				if (!this.validationRegex.test(this.control.value) && this.control.errors && this.control.errors.incorrect) {
					this.control.setValidators(Validators.pattern(this.validationRegex));
					this.control.updateValueAndValidity();
				}
			}
		}
	}

	onPaste(event) {
		if (navigator.onLine) {
			this.paste = true;
		}
	}

	clearEmbed() {
		if (navigator.onLine) {
			this.control.setValidators(Validators.pattern(this.validationRegex));
			this.control.updateValueAndValidity();
			this.control.patchValue(null);
		}
	}

	/**
 * @desc Field icon change method
 * @param object fieldIconEmit - field icon json data.
 */
	fieldIconData(icon) {
		this.fieldIconEmit.emit({ iconData: icon, value: this.control.value });
	}

	/**
	 * @desc Help line field change method
	 * @param object helpLineEmit - help line json data.
	 */
	helpLineData(data) {
		this.helpLineEmit.emit(data);
	}

}
